module.exports = "/_next/static/resources/life2-fe5e6b37d78492775589e85acfcfa42b.webp";